import { connect } from 'react-redux'
import { QUOTE_SUMMARY_PAGE } from 'constant'
import AlreadyInQuoteSubComponent from './AlreadyInQuoteSubComponent'

const withMapStateToProps = state => ({
  quotePageURL: QUOTE_SUMMARY_PAGE
})

export default connect(withMapStateToProps)(AlreadyInQuoteSubComponent)
